module.exports = __webpack_public_path__ + "img/schoolIcon.159d1fe6.png";